import { axiosOtherTrackerInstance } from "../../configs/AxiosInstance";

export const fetchUserTargetPlanWater = async (get, eventTypeId, clientId) => {
  try {
    const response = await get(
      `/fetch-user-target-plan-water?event_type_id=${eventTypeId}&client_id=${clientId}`,
      {
        instance: axiosOtherTrackerInstance,
      }
    );

    if (response && response.target_plan_water) {
      return {
        success: true,
        data: {
          created: response.target_plan_water.created || [],
          assigned: response.target_plan_water.assigned || [],
          both: response.target_plan_water.both || [],
        },
      };
    }

    return {
      success: false,
      message: "Target plan water data not found",
    };
  } catch (error) {
    console.error("Error fetching user target plan water:", error);
    return {
      success: false,
      message: "Error fetching user target plan water",
    };
  }
};
